import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { designTokens } from '../../../theming/design-tokens';

const { colors, spacing, borderRadius, mixins, typography } = designTokens;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: '100%',
      border: `1px solid ${colors.border.light}`,
      borderRadius: borderRadius.base,
      padding: theme.spacing(1),
    },
    headerContainer: {
      ...mixins.flexBetween,
      padding: theme.spacing(1),
      backgroundColor: colors.background.primary,
      marginBottom: theme.spacing(1),
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    restaurantDropdownContainer: {
      minWidth: 200,
    },
    restaurantDropdown: {
      minWidth: 280,
      '& .MuiSelect-select': {
        padding: `${spacing.sm} ${spacing.md}`,
      },
      '&.Mui-disabled': {
        backgroundColor: colors.background.disabled,
        color: colors.neutral.gray400,
      },
    },
    controlsContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing.sm,
    },
    editButton: {
      backgroundColor: colors.neutral.gray800,
      color: colors.neutral.white,
      fontWeight: typography.fontWeight.semibold,
      textTransform: 'none',
      borderRadius: borderRadius.base,
      '&:hover': {
        backgroundColor: colors.interactive.primaryHover,
      },
    },
    contentContainer: {
      backgroundColor: colors.background.primary,
      padding: theme.spacing(0.5),
    },
    editModeContainer: {
      ...mixins.flexColumn,
      gap: spacing.md,
    },
    editModeHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: spacing.md,
    },
    editModeCardContainer: {
      flex: 1,
    },
    editModeButtonContainer: {
      paddingTop: spacing.md,
    },
  }),
);
